'use strict';

const QuantityPickerPresenter = require('../presenters/quantitypicker');

const PickerView = require('./picker');

const QuantitiesView = require('./quantities');

class QuantityPickerView extends PickerView {
  initialize() {
    this.module = 'glive_booking_redesign';
    this.presenter = QuantityPickerPresenter;
    this.templateName = 'quantitypicker';
    this.contentView = QuantitiesView;
  }

  attributes() {
    return { 'data-bhw': 'GliveBookingDealBookerQuantities' };
  }

  className() {
    return 'picker glive-picker collapsed quantities';
  }
}
module.exports = QuantityPickerView;
